import normalize from "jsonapi-normalizer";
import { makeAutoObservable } from "mobx";
import { UsersContext } from "../../typings/context";
import { StudentProfileInfo } from "../../../api/typings/Profiles";
import { getUpdateStudentData } from "../../serializers/usersProfilesStudentsSerializer";
import { ProfilesStudentsApi } from "../../../api/users/ProfilesStudentsApi";

export class ProfileStudentService {
  constructor(private ctx: UsersContext) {
    this.ctx = ctx;
    makeAutoObservable(this);
  }

  updateProfile = async (data: StudentProfileInfo) => {
    const updateProfileData = await getUpdateStudentData(data);
    const response = await ProfilesStudentsApi.updateStudentProfile(data.id!, updateProfileData);
    const { users_profiles_students } = normalize(response).entities;
    this.ctx.usersProfilesStudents = { ...this.ctx.usersProfilesStudents, ...users_profiles_students };
  };
}
